import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Grid from '_utils/components/Corporate/Grid';
import { Primary as PrimaryContainer } from '_components/Corporate/TwoColumn/StyledTwoColumn';
import { mq, svg, text_s, link, showOnPrint } from '_utils/styles';
import { spacing } from '_utils/props';

export const Container = styled.div``;

export const List = styled(Grid.Row)`
  list-style: none;
  padding: 0;
  /* beat specificity of grid breakpoints */
  && {
    margin-top: 0;
  }
`;

const decreasedSpacing = css`
  ${({ theme }) => spacing({ theme, $mt: -1 })}
`;

export const ListItem = styled(Grid.Item)`
  /* background-color: #00000011; */

  ${mq.between('md', 'lg')} {
    /* skip first item */
    &:not(:first-child) {
      ${decreasedSpacing}
    }
  }

  /* hide bottom border on last item if showing all */
  .is-showing-all & {
    &:last-child {
      div {
        border-bottom: none;
      }
    }
  }

  ${mq('lg')} {
    /* skip first two items */
    &:not(:nth-child(-n + 2)) {
      ${decreasedSpacing}
    }

    /* hide bottom border on 2nd last item (if showing all and in bottom row) */
    .is-even-items &:nth-last-child(2) {
      div {
        border-bottom: none;
      }
    }
  }

  /* force single item or items in lhs of a 
     two column layout to be full width */
  &.is-single-item,
  ${PrimaryContainer} & {
    max-width: 100%;
    flex: 0 0 100%;
    ${mq('md')} {
      /* skip first item */
      &:not(:first-child) {
        ${decreasedSpacing}
      }
    }
  }

  ${mq('lg')} {
    margin-top: 0;
    align-self: stretch;
  }

  &.is-hidden {
    display: none;
    ${showOnPrint}
  }
`;

export const ShowMoreContainer = styled.div`
  ${({ theme }) => spacing({ theme, $mt: 3 })}
`;

export const FooterLinkContainer = styled.div`
  ${({ theme }) => spacing({ theme, $mt: 3 })}
`;

export const FooterLink = styled(NavLink)`
  ${link};
`;

export const FooterLinkLabel = styled(Text)`
  ${text_s}
`;

export const ArrowWrapper = styled.span`
  ${svg(14, 14)}
  width: 14px;
  margin-left: 6px;
  margin-right: 2px;

  path {
    fill: ${({ theme }) => theme.card.action};
  }
`;
